import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("增益（记盈亏）")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("发货退款（不记盈亏）")
const _hoisted_4 = { style: {"font-size":"12px","color":"#909399","margin-top":"4px","line-height":"1.4"} }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 增益：客服补偿 / 运营赠送等，会记入用户盈亏统计与平台亏损")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_9 = { style: {"font-size":"18px","font-weight":"bold"} }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"#e6a23c"} }, "⚠️", -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 充值确认 — ")
const _hoisted_12 = { style: {"color":"#67c23a","font-weight":"bold"} }
const _hoisted_13 = { style: {"color":"#f56c6c","font-size":"18px","font-weight":"bold"} }
const _hoisted_14 = { style: {"color":"#f56c6c","font-size":"20px","font-weight":"bold"} }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("确认充值")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref: "formRef",
      rules: _ctx.rules,
      model: _ctx.add_point_record,
      "label-width": "120px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "用户手机号码",
          prop: "mobile"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.add_point_record.mobile,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.add_point_record.mobile) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: _ctx.pointLabel,
          prop: "point"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.add_point_record.point,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.add_point_record.point) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: "类型",
          prop: "record_type"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_group, {
              modelValue: _ctx.add_point_record.record_type,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.add_point_record.record_type) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, { label: "gain" }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, { label: "refund" }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _hoisted_6,
              _createTextVNode(" 发货退款：用户发货未实际发出，返还" + _toDisplayString(_ctx.pointLabel) + "，不记盈亏（避免重复记账） ", 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "备注",
          prop: "note"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.add_point_record.note,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.add_point_record.note) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onSubmit(_ctx.formRef))),
              loading: _ctx.lookupLoading
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }, 8, ["loading"]),
            _createVNode(_component_el_button, { onClick: _ctx.onCancel }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["rules", "model"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.confirmDialogVisible,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.confirmDialogVisible) = $event)),
      width: "500px",
      "close-on-click-modal": false
    }, {
      header: _withCtx(() => [
        _createElementVNode("span", _hoisted_9, [
          _hoisted_10,
          _hoisted_11,
          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.pointLabel) + "充值", 1)
        ])
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.confirmDialogVisible = false))
        }, {
          default: _withCtx(() => [
            _hoisted_15
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.doCreate,
          loading: _ctx.submitting
        }, {
          default: _withCtx(() => [
            _hoisted_16
          ]),
          _: 1
        }, 8, ["onClick", "loading"])
      ]),
      default: _withCtx(() => [
        (Number(_ctx.add_point_record.point) >= 50000)
          ? (_openBlock(), _createBlock(_component_el_alert, {
              key: 0,
              title: "大额充值，请仔细核对",
              type: "warning",
              "show-icon": "",
              closable: false,
              style: {"margin-bottom":"16px"}
            }))
          : _createCommentVNode("", true),
        (_ctx.lookupUser)
          ? (_openBlock(), _createBlock(_component_el_descriptions, {
              key: 1,
              column: 1,
              border: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_descriptions_item, { label: "用户昵称" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.lookupUser.nickname || '-'), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "用户 ID" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.lookupUser.id), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "手机号" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.lookupUser.mobile), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "当前积分" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.lookupUser.point ?? 0), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "充值积分" }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_13, " +" + _toDisplayString(_ctx.add_point_record.point), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_descriptions_item, { label: "充值后积分" }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_14, _toDisplayString(Number(_ctx.lookupUser.point ?? 0) + Number(_ctx.add_point_record.point)), 1)
                  ]),
                  _: 1
                }),
                (_ctx.add_point_record.note)
                  ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                      key: 0,
                      label: "备注"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.add_point_record.note), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}